import React from "react";
import Text from "../../../common/typography/text";
import { formatNumber } from "../../../common/card";
import { useScreen } from "../../Utils/Screens";

const ProductsReview = ({
  productCodeData,
  orderTotal,
  priceTotal,
  manufacturerName,
  productGroupName,
  placedByName,
  isPhone,
}) => {
  return (
    <>
      <Text variant="h1">Product Summary</Text>
      <div className="direct-order-review-detail-container">
        <div className="direct-order-review-detail-child-container">
          <div className="direct-order-review-detail-text-container">
            <div className="direct-order-review-detail-title-text-container">
              <Text variant="bodyText" color="lightText">
                Placed By
              </Text>
            </div>
            <div className="direct-order-review-detail-content-text-container">
              <Text variant="bodyTextBold">{placedByName || "-"}</Text>
            </div>
          </div>
          <div className="direct-order-review-detail-text-container">
            <div className="direct-order-review-detail-title-text-container">
              <Text variant="bodyText" color="lightText">
                Manufacturer
              </Text>
            </div>
            <div className="direct-order-review-detail-content-text-container">
              <Text variant="bodyTextBold">{manufacturerName || "-"}</Text>
            </div>
          </div>
          <div className="direct-order-review-detail-text-container">
            <div className="direct-order-review-detail-title-text-container">
              <Text variant="bodyText" color="lightText">
                Product Group
              </Text>
            </div>
            <div className="direct-order-review-detail-content-text-container">
              <Text variant="bodyText">{productGroupName || "-"}</Text>
            </div>
          </div>
        </div>
      </div>
      {productCodeData.length > 0 && (
        <div className="direct-order-review-detail-container">
          {productCodeData?.map((product) => {
            return (
              <div
                key={product?.ProductID || product?.ProductCode}
                className="direct-order-review-detail-child-container"
              >
                <div
                  className="direct-order-review-child-content-container"
                  style={isPhone ? { flexDirection: "column" } : {}}
                >
                  <div className="direct-order-review-child-content-heading-container">
                    <div className="direct-order-review-detail-content-text-container">
                      <div
                        className="direct-order-review-detail-content-code-quality-container"
                        style={{ flexWrap: "wrap", alignItems: "baseline" }}
                      >
                        <Text variant="bodyText">
                          {product?.ProductName || "-"}
                        </Text>
                        {product?.ProductCode ? (
                          <Text variant="bodyTextBold">
                            {product.ProductCode}
                          </Text>
                        ) : null}
                      </div>
                    </div>
                    <div className="direct-order-review-detail-content-code-quality-container">
                      <Text variant="bodyText">
                        ${formatNumber(product?.Price).split(".")[0]}
                        <Text variant="bodyText">
                          .{formatNumber(product?.Price).split(".")[1]}
                        </Text>
                      </Text>
                      <Text variant="bodyText">x</Text>
                      <Text variant="bodyText">{product?.Quantity}</Text>
                    </div>
                  </div>
                  <Text variant="bodyTextBold">
                    $
                    {
                      formatNumber(
                        product?.Price * (product?.Quantity || 0),
                      ).split(".")[0]
                    }
                    <Text variant="bodyTextBold">
                      .
                      {
                        formatNumber(
                          product?.Price * (product?.Quantity || 0),
                        ).split(".")[1]
                      }
                    </Text>
                  </Text>
                </div>
              </div>
            );
          })}
        </div>
      )}

      <div className="direct-order-review-detail-container">
        <div className="direct-order-review-detail-child-container">
          <div
            className="direct-order-review-detail-text-container"
            style={{ width: "100%" }}
          >
            <div className="direct-order-review-detail-title-text-container">
              <Text variant="bodyText" color="lightText">
                Order Total
              </Text>
            </div>
            <div
              className="direct-order-review-detail-content-text-container"
              style={{ display: "flex", alignItems: "flex-end" }}
            >
              <Text variant="bodyTextBold">
                ${formatNumber(priceTotal).split(".")[0]}
                <Text variant="bodyTextBold">
                  .{formatNumber(priceTotal).split(".")[1]}
                </Text>
              </Text>
            </div>
          </div>
          <div
            className="direct-order-review-detail-text-container"
            style={{ width: "100%" }}
          >
            <div className="direct-order-review-detail-title-text-container">
              <Text variant="bodyText" color="lightText">
                Number of Products
              </Text>
            </div>
            <div
              className="direct-order-review-detail-content-text-container"
              style={{ display: "flex", alignItems: "flex-end" }}
            >
              <Text variant="bodyText">{orderTotal}</Text>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ProductsReview;
